import React from 'react'
import { render } from 'react-dom'
import TagManager from 'react-gtm-module'

import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'

import createHistory from 'history/createBrowserHistory'

import { routerMiddleware } from 'react-router-redux'

import I18n from 'redux-i18n'
import { translations } from './translations'

import 'moment/locale/pt-br'
import './sass/_app.sass'

import { createLogger } from 'redux-logger'

import App from './components/App'

import talkativeApp from './reducers'

const history = createHistory()

let middleware = [
  routerMiddleware(history)
]

if(process.env.NODE_ENV !== 'production') {
  middleware = [
    ...middleware,
    createLogger()
  ]
}

const store = createStore(
  talkativeApp,
  applyMiddleware(
    ...middleware
  )
);

const tagManagerArgs = {
  gtmId: 'GTM-ND4Z98T',
  dataLayerName: 'CheckoutDataLayer'
}

TagManager.initialize(tagManagerArgs)

render(
  <Provider store={store}>
    <I18n translations={translations} initialLang="pt">
      <App />
    </I18n>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js